// @ts-nocheck

import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { color, ColorProps } from 'styled-system';
import Flex from './Flex';

type EthAddressProps = ColorProps & {
  address: string;
  full?: boolean;
  isTxHash?: boolean;
  charLengthOnEitherSide?: number;
  showIcon?: boolean;
  iconSize?: number;
  iconColor?: string;
  onClick?(): any;
};

const AddressDisplay = styled(Flex)`
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Courier New', monospace;
  line-height: 1.75;
  ${color};
`;

const AddressValue = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex-shrink: 1;
  width: 100%;
  text-align: center;
`;

const EthAddress = ({
  address = '',
  showIcon = false,
  iconSize = 22,
  iconColor = 'copy',
  full = false,
  charLengthOnEitherSide = 4,
  onClick,
  ...rest
}: EthAddressProps) => {
  const displayedAddress = React.useMemo(() => {
    if (full || !address) return address;
    return `${address.slice(0, 2 + charLengthOnEitherSide)}...${address.slice(
      0 - charLengthOnEitherSide
    )}`;
  }, [address, full, charLengthOnEitherSide]);

  const [, setCopied] = useState(false);

  return onClick ? (
    <AddressDisplay {...rest} alignCenter onClick={onClick}>
      <AddressValue>{displayedAddress}</AddressValue>
    </AddressDisplay>
  ) : (
    <CopyToClipboard text={address} onCopy={() => setCopied(true)}>
      <AddressDisplay {...rest} onMouseLeave={() => setCopied(false)} alignCenter>
        <AddressValue>{displayedAddress}</AddressValue>
      </AddressDisplay>
    </CopyToClipboard>
  );
};

export default EthAddress;
